import React, { Component } from 'react';
import styles from './CreateRender.module.css';
import ReactSelect from 'react-select';
import Checkbox from 'rc-checkbox';
import Button from '../../components/Button';
import { connect } from 'react-redux';
import { fetchProducts, getProducts } from '../../modules/productFamily';
import { createJob } from '../../modules/jobs';
import { fetchModels } from '../../modules/models';
import { fetchTags, getTags } from '../../modules/tags';
import Divider from '../../components/Divider';
import ConfigPanel from '../../components/ConfigPanel';
import PropTypes from 'prop-types';
import { getScenes, fetchScenes } from '../../modules/scenes';

const imgQuality = [
  { title: '1K', note: '( 1000px x 1000px @300dpi )', value: 1000 },
  { title: '2K', note: '( 2000px x 2000px @300dpi )', value: 2000 },
  { title: '4K', note: '( 4000px x 4000px @300dpi )', value: 4000 },
  { title: '8K', note: '( 8000px x 8000px @300dpi )', value: 8000 },
];

const sdkVersions = [
  { label: '4.30.01', value: 'a6a838a0af5cfbf4fa489f985f0c7790d35d8767' },
  { label: '4.10.03', value: 'f0e5e9aef98b4927c30ce8ec38f5333aa6699842' },
];

const renderOptions = [
  { label: 'Normal', value: 'normal' },
  { label: 'Hero Shot', value: 'hero' },
  { label: 'Alternate Render View', value: 'alternate' },
  { label: 'Sectional Configurator', value: 'sectional' },
];

const rotationOptions = [
  { label: 'Preset Rotations', value: 'preset' },
  { label: 'Single Rotation', value: 'single' },
];

class CreateRender extends Component {
  state = {
    name: null,
    product: null,
    quality: null,
    manualName: null,
    manualProduct: null,
    manualQuality: null,
    loadingModels: true,
    modelOptions: [],
    modelSelected: [],
    rules: {},
    type: 'normal',
    manualType: 'normal',
    rotationType: 'single',
    manualRotationType: 'single',
    manualBackground: null,
    background: null,
    sdkVersion: null,
    manualsdkVersion: null,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  async componentDidMount() {
    const { fetchProducts, fetchTags, fetchScenes } = this.props;
    await fetchProducts();
    await fetchTags();
    await fetchScenes();
  }

  setProduct = async (data, type) => {
    if (type === 'manualProduct') {
      const tag = data && data.label.toLowerCase();
      const { fetchModels, products } = this.props;
      const models = await fetchModels({ tags: tag, limit: 200 });
      const modelOptions = Object.keys(models).map(key => ({
        label: models[key].friendlyName,
        value: models[key]._id,
      }));
      const rules = products[data && data.value].rules;
      this.setState({
        [type]: data && data.value,
        rules,
        modelOptions,
        loadingModels: false,
      });
    } else {
      this.setState({
        [type]: data && data.value,
      });
    }
  };

  setModels = data => {
    if (!data) return;
    const selected = data.map(item => item.value);
    this.setState({ modelSelected: selected });
  };

  setRenderRules = data => {
    const rules = data.rules;
    this.setState({ rules });
  };

  startManualRender = async () => {
    const {
      modelSelected,
      rules,
      manualQuality,
      manualName,
      manualType,
      manualRotationType,
      manualBackground,
      manualsdkVersion,
    } = this.state;
    const { createJob, scenes } = this.props;
    const { router } = this.context;
    if (!modelSelected || !rules || !manualQuality || !manualName) return;
    const renderAttrs = {
      type: 'renderModels',
      name: manualName,
      renderType: manualType,
      models: modelSelected,
      rules,
      width: manualQuality,
      height: manualQuality,
      rotationType: manualRotationType,
    };
    if (manualBackground) {
      renderAttrs.background = scenes[manualBackground];
    }
    if (manualsdkVersion) {
      renderAttrs.sdkVersion = manualsdkVersion;
    }

    const result = await createJob(renderAttrs);
    if (result) {
      router.history.push('/renderings');
    }
  };

  selectQuality = (e, type) => {
    this.setState({ [type]: e.target.id });
  };

  setRenderName = (e, type) => {
    const name = e.target.value;
    this.setState({ [type]: name });
  };

  startRender = async () => {
    const {
      product,
      quality,
      name,
      type,
      rotationType,
      background,
      sdkVersion,
    } = this.state;
    const { router } = this.context;
    if (!product || !quality || !name) return;
    const { createJob, scenes } = this.props;
    const collectionId = product;
    const data = {
      name,
      type: 'renderProduct',
      renderType: type,
      collectionId,
      width: quality,
      height: quality,
      rotationType,
    };
    if (background) {
      data.background = scenes[background];
    }
    if (sdkVersion) {
      data.sdkVersion = sdkVersion;
    }
    const result = await createJob(data);
    if (result) {
      router.history.push('/renderings');
    }
  };

  render() {
    const { products, tags, scenes } = this.props;
    const options = Object.keys(products).map(key => ({
      label: products[key].name,
      value: products[key]._id,
    }));
    const {
      product,
      type,
      sdkVersion,
      quality,
      loadingModels,
      modelOptions,
      modelSelected,
      manualProduct,
      manualQuality,
      manualType,
      rotationType,
      manualRotationType,
      background,
      manualsdkVersion,
      manualBackground,
    } = this.state;
    if (manualProduct) {
      products[manualProduct].materials = tags.map(item => item[0].value);
    }

    const sceneOptions = Object.keys(scenes).map(key => ({
      label: scenes[key].friendlyName,
      value: key,
    }));

    return (
      <div className={styles.container}>
        <div className={styles.header}> Create Render Job </div>
        <div className={styles.description}>
          Create final rendered images by select models, materials and scenes
        </div>
        <hr className={styles.divider} />
        <div className={styles.subTitle}> Render Single Collection</div>
        <div className={styles.renderTitle}>
          Name <span className={styles.required}> *</span>
        </div>
        <input
          className={styles.titleInput}
          onBlur={e => this.setRenderName(e, 'name')}
        />
        <div className={styles.renderTitle}>
          Type
          <span className={styles.required}> *</span>{' '}
        </div>
        <ReactSelect
          value={type}
          className={styles.select}
          options={renderOptions}
          onChange={data => this.setProduct(data, 'type')}
        />
        {type === 'alternate' && (
          <div>
            <div className={styles.renderTitle}>
              Select Rotation
              <span className={styles.required}> *</span>{' '}
            </div>
            <ReactSelect
              value={rotationType}
              className={styles.select}
              options={rotationOptions}
              onChange={data => this.setProduct(data, 'rotationType')}
            />
          </div>
        )}
        <div className={styles.renderTitle}>
          Collection
          <span className={styles.required}> *</span>{' '}
        </div>
        <ReactSelect
          value={product}
          className={styles.select}
          options={options}
          onChange={data => this.setProduct(data, 'product')}
        />
        {type === 'hero' && (
          <div>
            <div className={styles.renderTitle}>
              Select Background
              <span className={styles.required}> *</span>
            </div>
            <ReactSelect
              value={background}
              className={styles.select}
              options={sceneOptions}
              onChange={data => this.setProduct(data, 'background')}
            />
          </div>
        )}
        <div className={styles.renderTitle}>VRay Version</div>
        <ReactSelect
          value={sdkVersion}
          className={styles.select}
          options={sdkVersions}
          onChange={data => this.setProduct(data, 'sdkVersion')}
        />
        <div className={styles.renderTitle}>
          Select Render Quality <span className={styles.required}> *</span>{' '}
        </div>
        <div className={styles.renderQuality}>
          {imgQuality.map(item => (
            <div key={item.value} className={styles.qualityOption}>
              <Checkbox
                id={item.value}
                checked={item.value === quality}
                onChange={e => this.selectQuality(e, 'quality')}
              />
              <div className={styles.imgQuality}>
                {item.title}{' '}
                <span className={styles.qualityNote}>{item.note}</span>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.btnContainer}>
          <Button text="Start Render" onClick={this.startRender} />
        </div>
        <Divider />
        <div>
          <div className={styles.subTitle}> Manual Render</div>
          <div className={styles.renderTitle}>
            Name <span className={styles.required}>*</span>{' '}
          </div>
          <input
            className={styles.titleInput}
            onBlur={e => this.setRenderName(e, 'manualName')}
          />
          <div className={styles.renderTitle}>
            Select Type
            <span className={styles.required}> *</span>{' '}
          </div>
          <ReactSelect
            value={manualType}
            className={styles.select}
            options={renderOptions}
            onChange={data => this.setProduct(data, 'manualType')}
          />
          {manualType === 'alternate' && (
            <div>
              <div className={styles.renderTitle}>
                Select Rotation
                <span className={styles.required}> *</span>{' '}
              </div>
              <ReactSelect
                value={manualRotationType}
                className={styles.select}
                options={rotationOptions}
                onChange={data => this.setProduct(data, 'manualRotationType')}
              />
            </div>
          )}
          <div className={styles.renderTitle}>
            Select Collection <span className={styles.required}> *</span>
          </div>
          <ReactSelect
            value={manualProduct}
            className={styles.select}
            options={options}
            onChange={data => this.setProduct(data, 'manualProduct')}
          />
          {manualProduct && (
            <div>
              <div className={styles.renderTitle}> Select Model(s) </div>
              <ReactSelect
                multi={true}
                closeOnSelect={false}
                isLoading={loadingModels}
                className={styles.select}
                options={modelOptions}
                value={modelSelected}
                onChange={this.setModels}
              />
              {manualType === 'hero' && (
                <div>
                  <div className={styles.renderTitle}>
                    Select Background
                    <span className={styles.required}> *</span>
                  </div>
                  <ReactSelect
                    value={manualBackground}
                    className={styles.select}
                    options={sceneOptions}
                    onChange={data => this.setProduct(data, 'manualBackground')}
                  />
                </div>
              )}
              <div className={styles.renderTitle}> Select Material </div>
              <ConfigPanel
                product={products[manualProduct]}
                setProduct={this.setRenderRules}
                hiddenBtn={true}
                scenes={scenes}
              />
            </div>
          )}
          <div className={styles.renderTitle}>VRay Version</div>
          <ReactSelect
            value={manualsdkVersion}
            className={styles.select}
            options={sdkVersions}
            onChange={data => this.setProduct(data, 'manualsdkVersion')}
          />
          <div className={styles.renderTitle}> Select Render Quality </div>
          <div className={styles.renderQuality}>
            {imgQuality.map(item => (
              <div
                key={`manual-${item.value}`}
                className={styles.qualityOption}
              >
                <Checkbox
                  id={item.value}
                  checked={item.value === manualQuality}
                  onChange={e => this.selectQuality(e, 'manualQuality')}
                />
                <div className={styles.imgQuality}>
                  {item.title}{' '}
                  <span className={styles.qualityNote}>{item.note}</span>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.btnContainer}>
            <Button text="Start Render" onClick={this.startManualRender} />
          </div>
        </div>
      </div>
    );
  }
}

const stateToProps = state => ({
  products: getProducts(state),
  tags: getTags(state),
  scenes: getScenes(state),
});

export default connect(
  stateToProps,
  { fetchProducts, createJob, fetchModels, fetchTags, fetchScenes }
)(CreateRender);



// WEBPACK FOOTER //
// ./src/containers/CreateRender/index.js